/*----------  GET Request  ----------*/

const GetRequest = (url, params, success, fail) => {
	axios.get(url, { params }).then(response => {
		const { status, data } = response;
		if(success) success(status, data);
	}).catch(error => {
		if(error.response) {
			const { status, data } = error.response;
			if(fail) fail(status, data);
		} else {
			throw error;
		}
	});
}

/* ----------  Post Request  ---------- */

const PostRequest = (url, data, success, fail, options = {}) => {
	axios.post(url, data, options).then(response => {
		const { status, data } = response;
		if(success) success(status, data);
	}).catch(error => {
		if(error.response) {
			const { status, data } = error.response;
			if(fail) fail(status, data);
		} else {
			throw error;
		}
	});
}

/* ----------  Delete Request  ---------- */

const DeleteRequest = (url, data, success, fail) => {
	axios.delete(url, { data }).then(response => {
		const { status, data } = response;
		if(success) success(status, data);
	}).catch(error => {
		if(error.response) {
			const { status, data } = error.response;
			if(fail) fail(status, data);
		} else {
			throw error;
		}
	});
}

/* ----------  Put Request  ---------- */

const PutRequest = (url, data, success, fail) => {
	axios.put(url, data).then(response => {
		const { status, data } = response;
		if(success) success(status, data);
	}).catch(error => {
		if(error.response) {
			const { status, data } = error.response;
			if(fail) fail(status, data);
		} else {
			throw error;
		}
	});
}

/* ----------  Patch Request  ---------- */

const PatchRequest = (url, data, success, fail) => {
	axios.patch(url, data).then(response => {
		const { status, data } = response;
		if(success) success(status, data);
	}).catch(error => {
		if(error.response) {
			const { status, data } = error.response;
			if(fail) fail(status, data);
		} else {
			throw error;
		}
	});
}
